<template>
    <div class="home pt-4 pt-md-0">
        <section class="heading-section position-relative pt-5 pt-md-0">
          <vueper-slides
              autoplay
              :duration="3000"
              :touchable="false"
              fixed-height="90vh"
              :infinite="true"
              slide-image-inside
              :arrows="false"
              no-shadow
          >
              <vueper-slide
                  v-for="(slide, i) in sliders"
                  :key="i"
                  :image="slide.image"
                  :title="slide.title"
                  :content="slide.content"
              />
          </vueper-slides>
          <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center position-absolute top-0 heading-container">
            <p v-html="$t('home-heading')" />
            <span class="m-0 caption">{{$t('home-heading-caption')}}</span>
            <div class="d-flex flex-column flex-sm-row py-3">
              <button class="btn btn-primary text-secondary rounded-4 mx-2 my-2" @click="$router.push({name: 'products'})">{{$t('all-products')}}</button>
              <button class="btn btn-secondary text-primary rounded-4 mx-2 my-2" @click="$router.push({name: 'about'})">{{$t('about-matador')}}</button>
            </div>
          </div>
        </section>

        <!-- ratting section -->
        <section class="ratting pb-3 pt-5">
            <div class="container mx-auto row justify-content-center gap-3" >
                <p class="heading pb-4 fw-bold text-primary text-center">{{$t('our-values')}}</p>
                <div
                    class="col-auto px-0"
                >
                  <div
                    class="ratting-card-container"
                    data-aos="zoom-in"
                    data-aos-anchor=".ratting"
                    data-aos-duration="500"
                  >
                    <div class="ratting-card">
                      <img
                        src="../assets/images/Vector-3.svg"
                        alt=""
                      />
                      <p class="text-center">
                          {{
                              $t("Covering-all-the-customers-needs-is-our-focus")
                          }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                    class="col-auto px-0"
                >
                  <div
                    class="ratting-card-container"
                    data-aos="zoom-in"
                    data-aos-duration="500"
                    data-aos-anchor=".ratting"
                  >
                    <div class="ratting-card">
                      <img
                        src="../assets/images/Vector-1.svg"
                        alt=""
                      />
                      <p class="text-center">
                          {{
                              $t(
                                  "Supplying-high-quality-parts-for-the-latest-models"
                              )
                          }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                    class="col-auto px-0"
                >
                  <div
                    class="ratting-card-container "
                    data-aos="zoom-in"
                    data-aos-duration="500"
                    data-aos-anchor=".ratting"
                  >
                    <div class="ratting-card">
                      <img
                        src="../assets/images/Vector.svg"
                        alt=""
                      />
                      <p class="text-center">
                          {{ $t("Everything-you-need-in-one-place.") }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                    class="col-auto px-0"
                >
                  <div
                    class="ratting-card-container "
                    data-aos="zoom-in"
                    data-aos-duration="500"
                    data-aos-anchor=".ratting"
                  >
                    <div class="ratting-card">
                      <img
                        src="../assets/images/Vector-2.svg"
                        alt=""
                      />
                      <p class="text-center">
                          {{
                              $t(
                                  "Many-years-of-experience-in-identifying-our-customers-needs"
                              )
                          }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                class="col-auto px-0"
            >
              <div
                class="ratting-card-container "
                data-aos="zoom-in"
                data-aos-duration="500"
                data-aos-anchor=".ratting"
              >
                <div class="ratting-card">
                  <img
                    src="../assets/images/Vector-4.svg"
                    alt=""
                  />
                  <p class="text-center">
                    {{ $t('energy') }}
                  </p>
                </div>
              </div>
            </div>
            </div>
        </section>

        <!-- products -->
        <section class="container py-5">
            <div class="text-center">
                <p class="heading pb-5 fw-bold text-primary">
                    {{ $t("our-products") }}
                </p>
                <div class="position-relative d-flex justify-content-center">
                  <!-- Left Scroll Button -->
                  <div class="scroll-btn scroll-btn-left" @click="scrollLeft">
                    <i class="fas fa-chevron-left"></i>
                  </div>

                  <!-- Scrollable Category Wrapper -->
                  <div class="categories-container d-flex bg-secondary rounded-4 px-0" ref="categoriesContainer">
                    <router-link
                      v-for="category in categories"
                      :key="category.id"
                      :to="{ name: 'products', query: { category: category.slug } }"
                      class="category-btn rounded-4 py-2 px-2 px-sm-4 d-flex align-items-center"
                    >
                      <img :src="category.image" class="mx-1" />
                      <span class="mx-1">{{ category.name }}</span>
                    </router-link>
                  </div>

                  <!-- Right Scroll Button -->
                  <div class="scroll-btn scroll-btn-right" @click="scrollRight">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
            </div>
            <div
                class="products d-flex gap-4 flex-wrap justify-content-center pt-5"
            >
              <div
                v-for="(product, i) in filteredProducts.slice(0, 15)"
                :key="product.id"
              >
                <ProductCard
                  :product="product"
                  data-aos="zoom-out"
                  data-aos-duration="250"
                  data-aos-anchor=".products"
                  :data-aos-delay="i * 150"
                />
              </div>
            </div>
            <div
                v-if="filteredProducts.length ? false : true"
                class="text-center"
            >
                <p class="heading pb-2 text-primary fw-bold">No Result</p>
                <img
                    src="../assets/images/no-results.png"
                    class="text-center w-25"
                    alt=""
                />
            </div>
            <div class="text-center">
                <router-link
                    :to="{ name: 'products' }"
                    class="btn btn-primary text-white px-5 py-2 rounded-4 mt-5 me-2"
                    >{{ $t("see-all-products") }}</router-link
                >
                <button
                    class="btn btn-primary text-white px-5 py-2 rounded-4 mt-5"
                    @click="openPdf()"
                >
                    {{ $t("check-out-our-catalogue") }}
                </button>
            </div>
        </section>
        <section class="news container py-4">
            <p class="heading text-primary text-center fw-bold pb-3">
              {{ $t('articles') }}
            </p>
            <div class="d-flex justify-content-center gap-4 flex-wrap py-4">
              <div
                v-for="(news, i) in allNews.slice(0,4)"
                :key="news.id"
              >
                <NewsCard
                  :news="news"
                  data-aos="fade-up"
                  data-aos-duration="250"
                  data-aos-anchor=".news"
                  :data-aos-delay="i * 150"
                />
              </div>

              <div
                v-if="allNews.length === 0"
                class="text-center"
            >
                <p class="text-primary fw-bold">{{$t('no-news')}}</p>
                <img
                    src="../assets/images/no-results.png"
                    class="text-center w-25"
                    alt=""
                />
            </div>
            </div>
            <div class="text-center">
              <router-link
                  :to="{ name: 'news-index' }"
                  class="btn btn-primary text-white px-5 py-2 rounded-4 mt-5 mb-4"
                  >{{ $t("all-articles") }}</router-link
              >
          </div>
        </section>
        <!-- contact us -->
        <section class="contact-us container py-4">
            <p class="heading text-primary text-center fw-bold pb-3">
                {{ $t("contact-us") }}
            </p>
            <div class=" text-center caption mb-4">{{$t('contact-caption')}}</div>
            <form class="px-4" @submit.prevent="validateForm">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group text-start">
                            <label class="label">{{ $t("full-name") }}</label>
                            <input
                                type="text"
                                v-model="fullName"
                                class="form-control mb-4 mt-1 rounded-3 py-2 py-sm-4 bg-secondary"
                                :class="{ 'is-invalid': errors.fullName }"
                                :placeholder="$t('enter-your-name')"
                            />
                            <div v-if="errors.fullName" class="text-danger">
                                {{ errors.fullName }}
                            </div>
                        </div>
                        <div class="form-group text-start">
                            <label class="label">{{ $t("email") }}</label>
                            <input
                                type="email"
                                v-model="email"
                                class="form-control mb-4 mt-1 rounded-3 py-2 py-sm-4 bg-secondary"
                                :class="{ 'is-invalid': errors.email }"
                                :placeholder="$t('enter-your-email')"
                            />
                            <div v-if="errors.email" class="text-danger">
                                {{ errors.email }}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group text-start">
                            <label class="label">{{
                                $t("phone-number")
                            }}</label>
                            <input
                                type="text"
                                v-model="phoneNumber"
                                class="form-control mb-4 mt-1 rounded-3 py-2 py-sm-4 bg-secondary"
                                :class="{ 'is-invalid': errors.phoneNumber }"
                                :placeholder="$t('enter-your-phone-number')"
                            />
                            <div v-if="errors.phoneNumber" class="text-danger">
                                {{ errors.phoneNumber }}
                            </div>
                        </div>
                        <div class="form-group text-start">
                            <label class="label">{{ $t("type") }}</label>
                            <input
                                type="text"
                                v-model="messageType"
                                class="form-control mb-4 mt-1 rounded-3 py-2 py-sm-4 bg-secondary"
                                :class="{ 'is-invalid': errors.messageType }"
                                :placeholder="
                                    $t('choose-the-type-of-your-message')
                                "
                            />
                            <div v-if="errors.messageType" class="text-danger">
                                {{ errors.messageType }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group text-start">
                        <label class="label">{{ $t("message") }}</label>
                        <textarea
                            v-model="message"
                            class="form-control mb-4 mt-1 rounded-3 py-2 py-sm-4 bg-secondary"
                            :class="{ 'is-invalid': errors.message }"
                            :placeholder="$t('enter-your-message')"
                        ></textarea>
                        <div v-if="errors.message" class="text-danger">
                            {{ errors.message }}
                        </div>
                        <div class="text-center">
                            <button
                                type="submit"
                                class="btn btn-primary rounded-4 text-white mb-4 px-5 py-2"
                            >
                                {{ $t("send") }}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </section>

    </div>
</template>

<script>
import { WEBSITE_URL } from '@/constants'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import { mapState } from 'vuex'
import ProductCard from '../components/ProductCard.vue'
import NewsCard from '../components/NewsCard.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
export default {
  name: 'HomeView',
  components: { VueperSlides, VueperSlide, ProductCard, NewsCard },
  data () {
    return {
      fullName: '',
      email: '',
      phoneNumber: '',
      messageType: '',
      message: '',
      errors: {},
      senderDetails: null,
      searchString: '',
      pdfUrl: null,
      AOS
    }
  },
  methods: {
    validateForm () {
      this.errors = {}

      if (!this.fullName) {
        this.errors.fullName = this.$t('full-name-is-required')
      }
      if (!this.email) {
        this.errors.email = this.$t('email-is-required')
      } else if (!this.isValidEmail(this.email)) {
        this.errors.email = this.$t('invalid-email-address')
      }
      if (!this.phoneNumber) {
        this.errors.phoneNumber = this.$t('phone-number-is-required')
      } else if (!this.isValidPhoneNumber(this.phoneNumber)) {
        this.errors.phoneNumber = this.$t('invalid-phone-number')
      }
      if (!this.messageType) {
        this.errors.messageType = this.$t('message-type-is-required')
      }
      if (!this.message) {
        this.errors.message = this.$t('message-is-required')
      }

      if (Object.keys(this.errors).length === 0) {
        this.$store.dispatch('contactus/sendFeedback', {
          name: this.name,
          email: this.email,
          type: this.type,
          body: this.message
        })
      }
    },
    isValidEmail (email) {
      const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return re.test(email)
    },
    isValidPhoneNumber (phoneNumber) {
      const re = /^[0-9]{10,15}$/ // Simple phone number validation
      return re.test(phoneNumber)
    },
    openPdf () {
      const pdfUrl = WEBSITE_URL + '/files/file.pdf'
      window.open(pdfUrl, '_blank')
    },
    scrollLeft () {
      this.$refs.categoriesContainer.scrollBy({ left: -200, behavior: 'smooth' })
    },
    scrollRight () {
      this.$refs.categoriesContainer.scrollBy({ left: 200, behavior: 'smooth' })
    }
  },
  computed: {
    ...mapState({
      sliders: (state) => state.sliders.sliders,
      products: (state) => state.products.products,
      categories: (state) => state.categories.categories,
      allNews: state => state.news.news
    }),

    filteredProducts () {
      return this.products
        .filter((product) =>
          product.name
            .toLocaleLowerCase()
            .includes(this.searchString.toLocaleLowerCase())
        )
        .filter((product) =>
          this.$route.query.category
            ? product.categoriesIds.includes(
              this.getCategoriesBySlug(
                this.$route.query.category
              ).id
            )
            : true
        )
    }
  },
  created () {
    if (!this.sliders.length) {
      this.$store.dispatch('sliders/fetchAll')
    }
    if (!this.products.length) {
      this.$store.dispatch('products/fetchAll')
    }
    if (!this.categories.length) {
      this.$store.dispatch('categories/fetchAll')
    }
  },
  mounted () {
    AOS.init({
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/custom-bootstrap.scss";
.heading{
  font-size: 32px;
  @media(max-width: 576px) {
    font-size: 20px;
  }
}
// ratting
.heading-container{
  z-index: 3;
  pointer-events: none;

  background-color: rgba(40, 49, 67, 0.587);
  p{
    font-size: 60px;
    color: white;
    text-align:center;
    font-weight: 700;
    line-height:1.2;
    @media(max-width:1200px) {
      font-size: 50px;
    }
    @media(max-width: 992px) {
      font-size: 40px;
    }
    @media(max-width:768px) {
      font-size: 30px;
    }
    @media(max-width: 576px) {
      font-size: 28px;
    }
  }
  .caption{
    font-size: 23px;
    color: white;
    text-align: center;
    font-weight: 500;
    width: 400px;
    max-width: 90vw;
    @media(max-width:768px) {
      font-size: 16px;
    }
  }
  .btn{
    font-size: 16px;
    text-transform: capitalize;
    font-weight: 600;
    pointer-events: visible;
    padding: 10px 28px;
    @media(max-width: 576px) {
      padding: 6px 14px;
    }
  }
}
.ratting {
    .ratting-card{
      box-shadow: 0 0 15px 5px rgba(0,0,0,0.04);
      display: flex;
      width: 230px;
      max-width: 80vw;
      height: 230px;
      padding: 22px 22px 0 22px;
      flex-direction: column;
      justify-content: start;
      align-items: center;
      border-radius: 30px;
      font-weight: 600;
      font-size:17px ;
      transition: 0.15s ease-in;
      img{
        width: 50px;
        height: 50px;
        margin-bottom: 20px;
        transition: 0.15s ease-in;
      }
      @media(max-width: 576px) {
        width: 140px;
        padding: 12px 12px 0 12px;
        border-radius: 20px;
        height: 130px;
        font-size: 11px;
        img{
          width: 28px;
          height:28px;
          margin-bottom:10px;
        }
      }
      &:hover{
        transform: scale(1.03);
        box-shadow: 0 0 20px 8px rgba(0,0,0,0.045);
        img{
          transform: scale(1.1);
        }
      }
    }
}
.categories-container{
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  width: 70vw;
  max-width: 1200px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
  .category-btn{
    color:grey;
    font-weight: 500;
    display: flex;
    text-decoration: none;
    white-space: nowrap;
    img{
      filter: grayscale(100%);
      width: auto;
      height: 20px;
    }
    &:hover{
      background: #3d769f;;
      color:#F6F6F6;
      img{
        filter: grayscale(0%);;
      }
    }
    @media(max-width: 576px) {
      font-size: 12px;
      img{
        height: 14px;
      }
    }
  }
}
.scroll-btn{
  cursor: pointer;
  position: absolute;
  top: calc(50% - 13px);
  width: 20px;
}
.scroll-btn-left{
  left: 0%;
  @media(min-width:1200px) {
    left:4%;
  }
  @media(min-width: 1400px) {
    left: 0%;
  }
}
.scroll-btn-right{
  right: 0%;
  @media(min-width:1200px) {
    right:4%;
  }
  @media(min-width: 1400px) {
    right: 0%;
  }
}
// products
.search {
    width: 35%;
}
/*.card {
    width: 200px;
    .card-img-container {
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgb(250, 249, 249);
        height: 300px;
        width: 100%;
    }
    .card-img-top {
        // width: 75px;
        height: 250px;
        width: 75px;
    }
} */
.contact-us{
  @media(max-width: 576px) {
    text-align: center;
  }

  .caption{
    font-size: 20px;
    text-align: center;
    font-weight: 500;
    @media(max-width:768px) {
      font-size: 16px;
    }
  }
}
input::placeholder {
    color: #b9b9b9;
}
textarea::placeholder {
    color: #b9b9b9;
}
.btn-outline-primary:hover {
    color: white;
}
</style>

<style lang="scss">
// slider style
.vueperslides__bullet .default {
    background-color: #F6F6F6;
    border: none;
    box-shadow: 0 0 5px 2px rgba(0,0,0,0.02);
    transition: 0.3s;
    width: 13px;
    height: 13px;
    margin-bottom: 1rem;
}

.vueperslides__bullet--active .default {
    background-color: var(--bs-primary);
}

.vueperslides__bullet span {
    display: block;
    color: #fff;
    font-size: 10px;
    opacity: 0.8;
}

.vueperslide__image {
    z-index: -1;
}
</style>
